/**
 * Created with Mei Zhiwei on 2018-08-09 17:52:06.
 * Description: 文档类型，同时也是 tocID
 *
 * @author meizhiwei@meituan.com
 * @version 1.0.0
 * @Last Modified by: meizhiwei@meituan.com
 * @Last Modified time: 2018-08-09 20:29:04
 */
export const postTypes = {
  1: '接口文档',
  2: '业务文档',
  3: '开发文档',
  4: '帮助文档',
  5: '通知文档'
};



// WEBPACK FOOTER //
// ./src/config/postTypes.js